import { render, staticRenderFns } from "./chatBoxesDark.vue?vue&type=template&id=67dd2805&"
var script = {}
import style0 from "./chatBoxesDark.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports